import { SEC_ApiCall, SEC_DataApiPost } from '../func';

/** Load booking rooms, lesson names, week rules and saved timetable masters. */
export async function getBookingTimetableMasters() {
    const response = await SEC_ApiCall('sysmanager/bookings/timetables', {});
    if (
        !response
        || !Array.isArray(response.rooms)
        || !Array.isArray(response.lessonNames)
        || !Array.isArray(response.staff)
    ) {
        throw new Error('Unexpected timetable-master response.');
    }
    return response;
}

/** Create or update the timetable master assigned to one room and academic year. */
export async function saveBookingTimetableMaster(payload) {
    const response = await SEC_DataApiPost(
        'sysmanager/bookings/timetables',
        JSON.stringify(payload),
        {}
    );
    if (!response?.master || !Number.isInteger(Number(response.master.revision))) {
        throw new Error('Unexpected timetable-master save response.');
    }
    return response;
}
